import {
  peopleEmoji,
} from './emoji-list/index'

const emojiList = [
  ...peopleEmoji,
]

export default emojiList
